<template>
  <div class="account-detail">
    <!-- <div class="back btn">
      <i class="el-icon-arrow-left"></i>
      返回
    </div> -->
    <div class="account-info common">
      <div class="title">
        <span class="title-text">对账信息</span>
      </div>
      <div class="account-info-content">
        <div class="info-row">
          <div class="info-item">
            <div class="label">对账单号：</div>
            <div class="text">{{ detailInfo.reconciliationNo }}</div>
          </div>
          <div class="info-item">
            <div class="label">对账单名称：</div>
            <div class="text">{{ detailInfo.reconciliationName }}</div>
          </div>
        </div>
        <div class="info-row">
          <div class="info-item">
            <div class="label">对账接收方：</div>
            <div class="text">{{ detailInfo.supplierCompanyName }}</div>
          </div>
          <div class="info-item">
            <div class="label">对账发起方：</div>
            <div class="text">{{ detailInfo.purchaseCompanyName }}</div>
          </div>
        </div>

        <div class="info-row">
          <div class="info-item">
            <div class="label">对账时间：</div>
            <div class="text">{{ detailInfo.reconciliationDate }}</div>
          </div>
          <div class="info-item">
            <div class="label">对账单状态：</div>
            <div class="text">
              {{ getReconciliationStatus(detailInfo.reconciliationStatus) }}
            </div>
          </div>
        </div>
        <div class="info-row">
          <div class="info-item">
            <div class="label">对账单总金额：</div>
            <div class="text">{{ detailInfo.amount }}</div>
          </div>
          <div class="info-item"></div>
        </div>
        <div class="info-row">
          <div class="info-item">
            <div class="label">附件：</div>
            <div class="text">
              <div
                class="bg"
                v-for="(item, index) in detailInfo.fileList"
                :key="index"
                @click="downloadFile(item.fileUrl, item.fileName)"
              >
                {{ item.fileName }}
              </div>
            </div>
          </div>
          <div class="info-item"></div>
        </div>
        <div class="info-row">
          <div class="info-item">
            <div class="label">备注：</div>
            <div class="text">
              {{ detailInfo.remark }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="personal-info common">
      <div class="title">
        <span class="title-text">个人信息</span>
      </div>
      <div class="account-info-content">
        <div class="info-row">
          <div class="info-item">
            <div class="label">联系人：</div>
            <div class="text">{{ detailInfo.applyRealName }}</div>
          </div>
          <div class="info-item">
            <div class="label">联系电话：</div>
            <div class="text">{{ detailInfo.applyTelephone }}</div>
          </div>
        </div>
        <div class="info-row">
          <div class="info-item">
            <div class="label">邮箱：</div>
            <div class="text">{{ detailInfo.applyMail }}</div>
          </div>
          <div class="info-item"></div>
        </div>
      </div>
    </div>
    <div class="account-list common">
      <div class="title">
        <span class="title-text">对账明细</span>
        <span
          class="text-btn"
          @click="exportDetail"
          :disabled="tableData.length === 0"
        >
          导出全部对账明细
        </span>
      </div>
      <div class="search">
        <search
          :data="listQuery"
          :field-list="fieldList"
          :list-type-info="listTypeInfo"
          :width="listTypeInfo.width"
          @handleFilter="handleSearch"
          @handleReset="handleClear"
        />
      </div>
      <table-list
        :table-data="tableData"
        :table-label="tableLabel"
        :loading="loading"
      >
        <template #showIndex="slot">
          <span>{{
            (listQuery.pageNum - 1) * listQuery.pageSize + slot.scope.$index + 1
          }}</span>
        </template>
      </table-list>
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :total="total"
          :page-size.sync="listQuery.pageSize"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div>
    <div class="total common">
      <div class="title">
        <span class="title-text">对账金额总计</span>
      </div>
      <div class="total-content">
        <div class="total-row">
          <div class="total-item">
            <div class="label">对账单总金额总计：</div>
            <div class="money">
              ￥{{ formatMoney(detailInfo.amount ? detailInfo.amount : 0) }}
            </div>
          </div>
        </div>
        <div class="total-row">
          <div class="total-item">
            <div class="label">运费金额：</div>
            <div class="money">
              ￥{{
                formatMoney(
                  detailInfo.shippingCostAmount
                    ? detailInfo.shippingCostAmount
                    : 0
                )
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="back btn" @click="goBack">
        <i class="el-icon-arrow-left"></i>
        返回
      </div>
      <div
        class="handle-btn"
        v-if="detailInfo.reconciliationStatus === 1 && isDetail !== 'detail'"
      >
        <div class="btn" @click="openRefuseDialog(2)">拒绝</div>
        <div class="btn main-btn" @click="handleSure(1)">确认</div>
      </div>
    </div>

    <refuse-dialog
      :areaFormVisible.sync="areaFormVisible"
      @refuseHandle="refuseHandle"
    />
  </div>
</template>

<script>
import mixin from './mixin.js';
import api from '@/modules/projectA/api/order/index';
import utils from '@/modules/projectA/utils/utils';
import _ from 'lodash';
import RefuseDialog from './components/refuseDialog.vue';
export default {
  mixins: [mixin],
  components: { RefuseDialog },
  data() {
    return {
      areaFormVisible: false,
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        orderNo: '',
        productName: '',
      },
      detailInfo: {},
      fieldList: [
        { label: '订单号', type: 'input', value: 'orderNo', placeholder: '' },
        { label: '发货单号', type: 'dialog', value: 'shipNo', placeholder: '' },
        {
          label: '商品名称',
          type: 'input',
          value: 'productName',
          placeholder: '',
        },
      ],
      listTypeInfo: {
        width: {
          labelWidth: 120,
          itemWidth: 200,
        },
      },

      tableData: [],
      total: 0,
      tableLabel: [
        { label: '序号', slot: 'showIndex', align: 'center', width: '80' },
        {
          label: '订单号',
          param: 'orderNo',
          align: 'center',
          width: '180',
        },
        {
          label: '发货单号',
          param: 'shipNo',
          align: 'center',
          width: '180',
        },
        {
          label: '商品编号',
          param: 'productCode',
          align: 'center',
          width: '180',
        },
        {
          label: '商品名称',
          param: 'productName',
          align: 'center',
          width: '180',
        },
        {
          label: '单价(元)',
          param: 'price',
          align: 'center',
          width: '180',
        },
        {
          label: '采购数量',
          param: 'goodQuantity',
          align: 'center',
          width: '180',
        },
        {
          label: '对账数量',
          param: 'reconciliationQuantity',
          align: 'center',
          width: '180',
        },

        {
          label: '计量单位',
          param: 'goodsUnitName',
          align: 'center',
          width: '180',
        },
        {
          label: '运费',
          param: 'shippingCostAmount',
          align: 'center',
          width: '180',
        },
        {
          label: '小计',
          param: 'subtotal',
          align: 'center',
          width: '180',
        },
      ],
      loading: false,
      reconciliationStatusList: [
        {
          id: '',
          name: '全部',
        },
        {
          id: 1,
          name: '待确认',
        },
        {
          id: 2,
          name: '已确认',
        },
        {
          id: 3,
          name: '已拒绝',
        },
      ],
      isDetail: '',
    };
  },
  mounted() {
    const { purchaseCompanyId, reconciliationId, type } = this.$route.query;
    this.isDetail = type;
    this.listQuery.purchaseCompanyId = purchaseCompanyId;
    this.listQuery.reconciliationId = reconciliationId;

    this.getDetail({ reconciliationId, purchaseCompanyId });
    this.getList(this.listQuery);
  },
  methods: {
    getReconciliationStatus(status) {
      const { name } =
        this.reconciliationStatusList.find((item) => item.id === status) || {};
      return name;
    },
    async getDetail(params) {
      const result = await api.reconciliationDetail(params);
      console.log(result, 'purchaseCompanyId');
      if (result.code === '200') {
        this.detailInfo = { ...result.data };
      }
    },
    async getList(params) {
      const result = await api.reconciliationItemPage(params);
      if (result.code === '200') {
        const data = result.data;
        this.tableData = [...data.records];
        this.total = data.total;
      }
    },
    handleClear() {
      this.listQuery = { ...this.$options.data().listQuery };
      const { purchaseCompanyId, reconciliationId } = this.$route.query;
      this.listQuery.purchaseCompanyId = purchaseCompanyId;
      this.listQuery.reconciliationId = reconciliationId;
      this.getList(this.listQuery);
    },
    handleSearch(val) {
      this.listQuery = { ...val };
      const { purchaseCompanyId, reconciliationId } = this.$route.query;
      this.listQuery.purchaseCompanyId = purchaseCompanyId;
      this.listQuery.reconciliationId = reconciliationId;
      /* if (val?.time?.length) {
        this.listQuery.startTime = val.time[0];
        this.listQuery.endTime = val.time[1];
      } else {
        this.listQuery.startTime = "";
        this.listQuery.endTime = "";
      } */
      this.getList(this.listQuery);
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.listQuery.pageNum = 1;
      this.getList(this.listQuery);
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },
    formatMoney(s, n) {
      n = n > 0 && n <= 20 ? n : 2;
      s = parseFloat((s + '').replace(/[^\d\.-]/g, '')).toFixed(n) + '';
      let l = s.split('.')[0].split('').reverse();
      let r = s.split('.')[1];
      let t = '';
      for (let i = 0; i < l.length; i++) {
        t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? ',' : '');
      }
      return t.split('').reverse().join('') + '.' + r;
    },
    exportDetail: _.debounce(async function () {
      const result = await api.exportReconciliationDetail(this.listQuery);
      if (result?.code === '500') {
        return;
      }
      if (result.type == 'application/json') {
        utils.fileExportResponseError(result);
      } else {
        const time = utils.formatDate(new Date(), 'yyyyMMdd');
        utils.downFile(result, `对账单明细信息${time}`);
      }
    }),
    openRefuseDialog() {
      this.areaFormVisible = true;
    },
    refuseHandle(refuseReason, confirmStatus) {
      console.log(refuseReason);
      const { supplierCompanyId, reconciliationId, purchaseCompanyId } =
        this.detailInfo;
      this.reconciliationConfirm({
        supplierCompanyId,
        reconciliationId,
        purchaseCompanyId,
        confirmStatus,
        refuseReason,
      });
    },
    async reconciliationConfirm(params) {
      console.log(params);
      const result = await api.reconciliationConfirm(params);
      if (result.code === '200') {
        if (params.confirmStatus === 1) {
          this.$message({
            type: 'success',
            message: '确认成功!',
          });
        } else {
          this.$message({
            type: 'success',
            message: '已拒绝!',
          });
        }
        this.goBack();
      }
    },
    handleSure(confirmStatus) {
      this.$confirm('是否对当前对账单执行确认操作？', '消息提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const { supplierCompanyId, reconciliationId, purchaseCompanyId } =
            this.detailInfo;
          this.reconciliationConfirm({
            supplierCompanyId,
            reconciliationId,
            purchaseCompanyId,
            confirmStatus,
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消确认',
          });
        });
    },
    goBack() {
      this.$router.push({ path: '/accountOrder' });
    },
    downloadFile(fileUrl, fileName = '下载文件') {
      // 通过 url 下载文件并给文件重新起名字
      const downloadRes = async () => {
        let response = await fetch(fileUrl); // 内容转变成blob地址
        let blob = await response.blob(); // 创建隐藏的可下载链接
        let objectUrl = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileName;
        a.click();
        a.remove();
      };
      downloadRes();
    },
  },
};
</script>
<style lang="scss" scoped>
.btn {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-width: 80px;
  height: 30px;
  padding: 0 10px;
  border: 1px solid #d9d9d9;
  margin-right: 20px;
  background: #fff;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  &:last-child {
    margin-right: 0;
  }
}
.main-btn {
  background: #2587ff;
  color: #fff;
}
.text-btn {
  font-size: 14px;
  font-weight: 350;
  color: #0064c8;
  margin-left: 20px;
  cursor: pointer;
  text-decoration: underline;
}
.bg {
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 350;
  color: #0064c8;
  padding-left: 24px;
  cursor: pointer;
  // text-decoration: underline;
  // background: url("../../../../../assets/img/account/Vector.png") no-repeat center left;
  background-size: 12px 16px;
}
.account-detail {
  .back {
    display: inline-block;
    color: #333;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background: #fff;
  }
  .common {
    margin-top: 20px;
    padding: 20px;
    background: #fff;
    .title {
      display: flex;
      align-items: center;
      font-family: Source Han Sans CN;
      font-size: 16px;
      font-weight: 500;
      line-height: 1;
    }
    .info-row {
      display: flex;
      .info-item {
        flex: 1;
        display: flex;
        margin-top: 20px;
        .label {
          flex-shrink: 0;
          flex-grow: 0;
          width: 112px;
          text-align: right;
          white-space: nowrap;
          line-height: 1;
          font-size: 14px;
        }
        .text {
          line-height: 1;
          font-size: 14px;
        }
      }
    }
  }
  .account-list {
    .search {
      padding: 20px 0;
      background: #fff;
      ::v-deep .search-content {
        .item-style {
          margin: 0;
          margin-bottom: 10px;
        }
      }
    }

    .pagination-box {
      text-align: right;
      margin-top: 20px;
      margin-bottom: 0;
      ::v-deep .el-pagination {
        button {
          height: 30px;
          color: #999;
        }
        .el-select {
          .el-input__inner {
            border-radius: 0;
            height: 30px;
          }
        }
        .el-input__inner {
          border-radius: 0;
          height: 30px;
          color: #999;
        }
        .el-select-dropdown__item,
        .el-pagination__jump,
        .el-pagination__total {
          color: #999;
        }
        .el-pager {
          li {
            border-radius: 0;
            border: 1px solid #d9d9d9;
            line-height: 28px;
            text-align: center;
            margin-left: 10px;
            width: 40px;
            height: 30px;
            color: #999;
            &:first-child {
              margin-left: 0;
            }
          }
          .active {
            background: #2587ff;
            border: none;
            color: #fff;
          }
        }
      }
    }
  }
  .total {
    .total-content {
      margin-top: 10px;
      padding: 0 20px 20px 0;
      border: 1px solid #ededed;
      .total-row {
        display: flex;
        justify-content: flex-end;
        .total-item {
          display: flex;
          margin-top: 20px;
          .label {
            font-size: 14px;
            font-weight: 500;
            color: #333;
          }
          .money {
            color: #f0250f;
            font-size: 14px;
            font-weight: 700;
          }
        }
      }
    }
  }
  .footer {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    .handle-btn {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
